import React, { CSSProperties } from 'react';

interface GradientBackgroundProps {
  children: React.ReactNode;
  gradientColors: string[];
  style?: CSSProperties;
  className?: string;
}

const GradientBackground: React.FC<GradientBackgroundProps> = ({
  children,
  gradientColors,
  style,
  className,
}) => {
  const gradient = `linear-gradient(90deg, ${gradientColors.join(', ')})`;

  return (
    <div
      className={className}
      style={{
        background: gradient,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default GradientBackground;
